const InfoItem = ({ title, className = "", children }) => {
  return (
    <p className={`mt-1 ${className}`}>
      <span>{title}: </span>
      <span className="fw-bold" dir="auto">
        {children || "تعریف نشده"}
      </span>
    </p>
  );
};

export default InfoItem;
